<div>
  <div class="twoColHeader">
    <div class="colOne">
      <h1>Profile</h1>
    </div>
    <div class="colTwo change-password">
      <img src="assets/images/change-password.png" (click)="changePassword()" style="width: 30px; cursor: pointer;"
        title="Change Password">
    </div>
  </div>

  <div class="twoCol">
    <div class="colOne">
      <div class="image-group">
        <div><label for="UploadControl" title="Click to change profile image" style="cursor: pointer;">
            <img class='imgProfile' for="UploadControl" [src]="appComponent.user.profileImage ? 
                appComponent.user.profileImage : 
                'data:image/png;base64,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' 
                | safe: 'resourceUrl'">
          </label> <br />
        </div>
        <div>
          <div style="display: flex;">
            <input type='file' (change)="onSelectFile($event)" id="UploadControl" style="display:none;"
              accept="image/png, image/gif, image/jpeg" />
            <label for="UploadControl" id="lblUploadText" class="UploadPhoto"
              title="Click to change profile image">Upload
              your photo</label>
          </div>
          <p class="uploadHelp">Recommended Size:
            <br>
            200px X 200px
          </p>
        </div>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input #usersEmailAddress matInput disabled='true' [(ngModel)]="appComponent.user.usersEmail" />
      </mat-form-field>
      <br>
      <mat-form-field appearance="outline">
        <mat-label>Legal Name</mat-label>
        <input #legalName matInput placeholder="Enter legal name..." minlength="1" maxlength="30"
          [(ngModel)]="appComponent.user.legalName" />
        <mat-error *ngIf="legalName.invalid">required</mat-error>
      </mat-form-field>
      <br>
      <mat-form-field appearance="outline">
        <mat-label>Display Name</mat-label>
        <input #displayName matInput placeholder="Enter display name..." minlength="1" maxlength="30"
          [(ngModel)]="appComponent.user.displayName" />
        <mat-error *ngIf="displayName.invalid">required</mat-error>
      </mat-form-field>
      <br>
      <!-- <p class="matLabelWithNoOutline">Time Zone</p>
      <select #timeZone id="time" class="inputEffect">
        <option *ngFor="let alltimeZone of alltimeZones; let i = index"
          [selected]="alltimeZone.timeZoneId == appComponent.user.timeZone" [value]="alltimeZones[i].timeZoneId">
          {{alltimeZones[i].display}}
        </option>
      </select> -->

      <p class="matLabelWithNoOutline">Time Zone</p>
      <select #timeZone id="time" class="inputEffect" [(ngModel)]="appComponent.user.timeZone">
        <option *ngFor="let timeZone of alltimeZones" [value]="timeZone.timeZoneId">
          {{timeZone.display}}
        </option>
      </select>


      <p class="matLabelWithNoOutline">Preferred Language for AI Tools</p>
      <select #preferredLanguage id="time" class="inputEffect" [(ngModel)]="appComponent.user.preferredLanguageISO639">
        <option></option>
        <option *ngFor="let language of openAIService.supportedLanguages" [value]="language.code">
          {{language.name}}
        </option>
      </select>

      <!-- </div> -->
      <div id="successfull" style="display: block; color: #055cc2; font-weight: bold;">
        {{successmsg}}
      </div>
      <button ejs-button class="success" (click)="updateProfile()">
        <img src="assets/images/progress-spinner.gif" class="button-spinner" *ngIf="loading" />
        Save Profile Changes
      </button>
    </div>
    <!-- 2nd COL -->
    <div class="colTwoInfo">
      <h2>Additional Information:</h2>
      <h3>Change Password:</h3>
      <img src="assets/images/change-password.png" (click)="changePassword()" style="width: 24px; cursor: pointer;"
        title="Change Password">
      <h3>Profile Photo:</h3>
      <p>Displayed solely within the application for identification purposes.</p>
      <h3>Email (disabled):</h3>
      <p>This is your login credential and can only be changed by contacting support.</p>
      <h3>Legal Name:</h3>
      <p>This name is used on all officially generated reports and documents.</p>
      <h3>Display Name:</h3>
      <p>This name is visible to your team members and used for in-app interactions.</p>
      <h3>Time Zone:</h3>
      <p>Adjusts the display of date/time in the application and time-related data in generated reports.</p>
      <h3>Preferred Language for AI Tools:</h3>
      <p>AI Tools respond in your preferred language when the same language is used as input.</p>
      <p>Note: English input defaults to English responses, regardless of your preferred language setting.</p>
    </div>
  </div>
</div>

<!-- Change Password Dialog -->
<ejs-dialog id='ejDialogChangePassword' #ejDialogChangePassword showCloseIcon='true' header='Change Password'
  [target]='targetElement' width='600px' [visible]="false" isModal="true">

  <p class="uploadHelp">Minimum Requirements:<br>
  <ul>
    <li class="uploadHelp">8 Characters</li>
    <li class="uploadHelp">1 Upper</li>
    <li class="uploadHelp">1 Lower</li>
    <li class="uploadHelp">1 Digit</li>
  </ul>
  <form [formGroup]="form" (ngSubmit)="onSubmit(form)" novalidate>
    <div class="project-modal-content">

      <mat-form-field appearance="outline" class="fitErrorMsg">
        <mat-label>Password</mat-label>
        <input #password matInput placeholder="Enter new password..." formControlName="password" type="password"
          minlength="1" maxlength="30" autocomplete="new-password" />
        <mat-error
          *ngIf="form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)">
          Password does not meet minimum requirements - 8 chars - 1 Upper - 1 Lower - 1 Digit</mat-error>
      </mat-form-field>
      <br>
      <mat-form-field appearance="outline" class="fitErrorMsg">
        <mat-label>Password</mat-label>
        <input #c_password matInput placeholder="Confirm new password..." formControlName="c_password" type="password"
          minlength="1" maxlength="30" autocomplete="new-password" />
        <mat-error
          *ngIf="form.controls['c_password'].invalid && (form.controls['c_password'].dirty || form.controls['c_password'].touched)">
          Password does not meet minimum requirements - 8 chars - 1 Upper - 1 Lower - 1 Digit</mat-error>
        <mat-error *ngIf="form.controls['c_password'].value != form.controls['password'].value">Password do not
          match</mat-error>
      </mat-form-field>


    </div>
    <div class="project-modal-action">
      <button ejs-button class="cancel" type="button" (click)="hideDialog()">
        Cancel
      </button>
      <button ejs-button type="submit" class="success">
        <img src="assets/images/project.gif" class="button-spinner" *ngIf="loading" />
        Update Password
      </button>
    </div>
  </form>

</ejs-dialog>